import { WifiOffIcon } from 'lucide-react'

import {
  Feedback,
  FeedbackAction,
  FeedbackContent,
  FeedbackDescription,
  FeedbackEventId,
  FeedbackImage,
  FeedbackLayout,
  FeedbackTitle,
} from '@/components/ui/feedback'
import useTranslator from '@/hooks/translation'

import { FeedbackRetryButton } from './retry-button'

interface FeedbackNetworkErrorProps {
  layout?: FeedbackLayout
  title?: string
  description?: string
  eventId?: string
  onRetry?: VoidFunction
  isRetrying?: boolean
  className?: string
}

export function FeedbackNetworkError({
  layout = 'default',
  title,
  description,
  eventId,
  onRetry,
  isRetrying = false,
  className,
}: FeedbackNetworkErrorProps) {
  const { getTranslation } = useTranslator()

  const defaultTitle = getTranslation(
    'common.messages.errors.networkError.title',
  )

  const defaultDescription = getTranslation(
    'common.messages.errors.networkError.description',
  )

  return (
    <Feedback layout={layout} variant="error" className={className}>
      <FeedbackImage
        src="/images/error/network-error-content.png"
        alt="Network Error"
        width={190}
        height={190}
      />

      <FeedbackContent>
        <FeedbackTitle>
          {layout === 'compact' && <WifiOffIcon />}
          {title || defaultTitle}
        </FeedbackTitle>

        <FeedbackDescription>
          {description || defaultDescription}
        </FeedbackDescription>

        {eventId && <FeedbackEventId eventId={eventId} />}
      </FeedbackContent>

      {onRetry && (
        <FeedbackAction>
          <FeedbackRetryButton
            variant={layout === 'default' ? 'fintalk' : 'outline'}
            onRetry={onRetry}
            isRetrying={isRetrying}
          />
        </FeedbackAction>
      )}
    </Feedback>
  )
}
